import { useFormikContext } from "formik";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { EventTypeOptionResource } from "../../types/eventType";
import { EventOffboardingStepKey } from "./EventOffboardingStepper";

export function shouldSkipKeyMetricsStep(eventType: EventTypeOptionResource | null): boolean {
	return (
		eventType?.visitorsMetricRequirement === "prohibited" &&
		eventType?.invitedPersonsMetricRequirement === "prohibited" &&
		eventType?.registrationsMetricRequirement === "prohibited" &&
		eventType?.customersMetricRequirement === "prohibited" &&
		eventType?.employeesMetricRequirement === "prohibited" &&
		eventType?.eventReachMetricRequirement === "prohibited" &&
		eventType?.eventGoalRatingMetricRequirement === "prohibited"
	);
}

export function shouldSkipCostsStep(eventType: EventTypeOptionResource | null): boolean {
	if (!eventType?.costCategoryRequirements?.length) {
		return true;
	}
	return eventType?.costCategoryRequirements.every((c) => c.requirement === "prohibited");
}

export function shouldSkipOffboarding(eventType: EventTypeOptionResource | null): boolean {
	return shouldSkipKeyMetricsStep(eventType) && shouldSkipCostsStep(eventType);
}

export const useSubmitOffboardingStep = () => {
	const navigate = useNavigate();
	const { submitForm } = useFormikContext();

	return useCallback(
		async (eventType: EventTypeOptionResource | null, currentStep: EventOffboardingStepKey): Promise<void> => {
			switch (currentStep) {
				case "key-metrics":
					shouldSkipCostsStep(eventType) ? submitForm() : navigate("../costs");
					break;
				case "costs":
					submitForm();
					break;
			}
		},
		[navigate, submitForm],
	);
};
